/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The meter value tag available
 */
export enum ChargePointMeterValuesTag {
  VALUE = 'VALUE',
  CURRENT_EXPORT = 'CURRENT.EXPORT',
  CURRENT_IMPORT = 'CURRENT.IMPORT',
  CURRENT_OFFERED = 'CURRENT.OFFERED',
  ENERGY_ACTIVE_EXPORT_REGISTER = 'ENERGY.ACTIVE.EXPORT.REGISTER',
  ENERGY_ACTIVE_IMPORT_REGISTER = 'ENERGY.ACTIVE.IMPORT.REGISTER',
  ENERGY_REACTIVE_EXPORT_REGISTER = 'ENERGY.REACTIVE.EXPORT.REGISTER',
  ENERGY_REACTIVE_IMPORT_REGISTER = 'ENERGY.REACTIVE.IMPORT.REGISTER',
  ENERGY_ACTIVE_EXPORT_INTERVAL = 'ENERGY.ACTIVE.EXPORT.INTERVAL',
  ENERGY_ACTIVE_IMPORT_INTERVAL = 'ENERGY.ACTIVE.IMPORT.INTERVAL',
  ENERGY_REACTIVE_EXPORT_INTERVAL = 'ENERGY.REACTIVE.EXPORT.INTERVAL',
  ENERGY_REACTIVE_IMPORT_INTERVAL = 'ENERGY.REACTIVE.IMPORT.INTERVAL',
  FREQUENCY = 'FREQUENCY',
  POWER_ACTIVE_EXPORT = 'POWER.ACTIVE.EXPORT',
  POWER_ACTIVE_IMPORT = 'POWER.ACTIVE.IMPORT',
  POWER_FACTOR = 'POWER.FACTOR',
  POWER_OFFERED = 'POWER.OFFERED',
  POWER_REACTIVE_EXPORT = 'POWER.REACTIVE.EXPORT',
  POWER_REACTIVE_IMPORT = 'POWER.REACTIVE.IMPORT',
  RPM = 'RPM',
  SOC = 'SOC',
  TEMPERATURE = 'TEMPERATURE',
  VOLTAGE = 'VOLTAGE'
}
